import { IMPERSONATION_HEADER } from "@unbox/api";
import posthog from "posthog-js";
import { clearLastAccessed } from "@/utils/last-accessed";

// An impersonated session is scoped to one tab: the admin's own token still
// authenticates every request, and this id tells the API which user to act as.
const KEY = "impersonated_user_id";

export const getImpersonatedUserId = (): string | null => {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
};

export const impersonationHeaders = (): Record<string, string> => {
  const id = getImpersonatedUserId();
  return id ? { [IMPERSONATION_HEADER]: id } : {};
};

/** Reloads the app so no state survives across the switch of session in either direction. */
export const startImpersonation = (userId: string): void => {
  sessionStorage.setItem(KEY, userId);
  clearLastAccessed();
  window.location.assign("/");
};

export const stopImpersonation = (): void => {
  sessionStorage.removeItem(KEY);
  posthog.resetPersonPropertiesForFlags();
  clearLastAccessed();
  window.location.assign("/");
};
